export default __webpack_public_path__ + "static/media/19_mobile.87dfd936.jpg";